// Unpublished Work © 2024 Deere & Company.
import { Search } from "@deere/fuel-react";
import { SxProps } from "@mui/material";
import { useTranslation } from "react-i18next";

const DataGridProSearch = ({
  sx,
  searchTerm,
  updateSearchTerm,
}: {
  sx?: SxProps;
  searchTerm: string;
  updateSearchTerm: any;
}) => {
  const { t } = useTranslation("common");
  const placeholder = t("table.globalSearch.placeholder");

  return (
    <Search
      data-testid="data-grid-search"
      sx={sx}
      onChange={(event) => {
        const newValue = event.target.value;
        updateSearchTerm(newValue);
      }}
      value={searchTerm}
      onClear={() => {
        updateSearchTerm("");
      }}
      placeholder={placeholder}
    />
  );
};

export default DataGridProSearch;
